import * as serviceWorker from './registerServiceWorker';
import React, {
  Component
} from 'react';
import ReactDOM, {
  render
} from 'react-dom';
// import { HashRouter as Router, withRouter } from 'react-router-dom';
import * as mobx from 'mobx';
import * as ReactRouterDom from 'react-router-dom';
import * as mobxReact from 'mobx-react';
import classnames from 'classnames';
import moment from 'moment';

window.React = React;
window.ReactDOM = ReactDOM;
window.ReactRouterDom = ReactRouterDom;
window.mobx = mobx;
window.mobxReact = mobxReact;
window.classnames = classnames;
window.moment = moment;

if(window.ecologyContentPath) {
  // 添加二级路径给 img
  const e9HooksOld = {
    ...window.e9Hooks
  };
  window.e9Hooks = {
    ...window.e9Hooks,
    reactDOMSetInnerHTML: (node, html) => {
      let newHtml = `${html}`;
      if (typeof e9HooksOld.reactDOMSetInnerHTML === "function") {
        newHtml = e9HooksOld.reactDOMSetInnerHTML(node, html) || `${html}`;
      }
      const imgReg = /<(img|a|iframe)\s[^>]+\/?>/gi;
      let match = newHtml.match(imgReg);
      if (match && match.length) {
        const srcReg = /(src|href)=[\'\"]?([^\'\"]*)[\'\"]?\s/i;
        newHtml = newHtml.replace(imgReg, () => "{~}");
        match.forEach(m => {
          m = m.replace(imgReg, img => {
            const srcMatch = img.match(srcReg);
            if (srcMatch && srcMatch.length) {
              const src = srcMatch[2];
              const reg = new RegExp(`^${window.ecologyContentPath}`);
              if (src && !reg.test(src) && /^\//.test(src)) {
                return img.replace(
                  srcReg,
                  () => `${/^src/.test(srcMatch[0]) ? "src" : "href"}="${window.ecologyContentPath}${src}"`
                );
              }
            }
            return img;
          });
          newHtml = newHtml.replace(/{~}/, () => m);
        });
        node.innerHTML = newHtml;
      } else {
        // default
        node.innerHTML = newHtml;
      }
      return newHtml;
    },
    reactDOMSetAttribute: (
      isCustomComponentTag,
      propertyInfo,
      node,
      attributeName,
      attributeValue,
      attributeNamespace
    ) => {
      let newAttributeValue = attributeValue;
      if (typeof e9HooksOld.reactDOMSetAttribute === "function") {
        newAttributeValue = e9HooksOld.reactDOMSetAttribute(
          isCustomComponentTag,
          propertyInfo,
          node,
          attributeName,
          attributeValue,
          attributeNamespace
        );
      }
      if (
        window.ecologyContentPath &&
        ((node.nodeName === "IMG" && attributeName === "src") ||
          (node.nodeName === "IFRAME" && attributeName === "src") ||
          (node.nodeName === "A" && attributeName === "href"))
      ) {
        const reg = new RegExp(`^${window.ecologyContentPath}`);
        if (!reg.test(newAttributeValue) && /^\//.test(newAttributeValue)) {
          newAttributeValue = window.ecologyContentPath + newAttributeValue;
        }
      }
      // default
      if (isCustomComponentTag || propertyInfo === null) {
        node.setAttribute(attributeName, newAttributeValue);
        return newAttributeValue;
      }
      if (propertyInfo.mustUseProperty) {
        node[attributeName] = newAttributeValue;
        return newAttributeValue;
      }
      if (attributeNamespace) {
        node.setAttributeNS(
          attributeNamespace,
          attributeName,
          newAttributeValue
        );
        return newAttributeValue;
      } else {
        node.setAttribute(attributeName, newAttributeValue);
        return newAttributeValue;
      }
    }
  };
}

// import { Modal, Tools } from 'weaver-mobile';
// import { RouteLayout } from 'weaver-mobile-page';

// @withRouter
// class Frame extends Component {
//   componentDidMount() {
//     const { history } = this.props;
//     history.push(this.getPath());
//   }
//   getPath = () => {
//     const { location: { pathname } } = this.props;
//     return /\/viewframe$/.test(pathname) ? pathname : `${pathname}/viewframe`;
//   }
//   render() {
//     const { src } = this.props;
//     return (
//       <RouteLayout.Frame
//         id="viewframe"
//         path={this.getPath()}
//         iframeProps={{ src }}
//       />
//     );
//   }
// }
// window.weaJs = {
//   callApi: Tools.callApi,
//   alert: (message = '') => Modal.alert('', message),
//   showDialog: (src = '') => {
//     let wrap = window.document.getElementById('frameOfShowDialog');
//     if (!wrap) {
//       wrap = window.document.createElement('div');
//       wrap.id = 'frameOfShowDialog';
//       window.document.body.appendChild(wrap);
//     }
//     const Root = () => (
//       <Router>
//         <Frame src={src} />
//       </Router>
//     );
//     render(<Root />, wrap);
//   }
// };

serviceWorker.register();


// WEBPACK FOOTER //
// ./pre.js